import type { THttpMethod } from '@glomopay/utils';

export enum ApiEndpoint {
  RESOLVE_ENTRY = 'RESOLVE_ENTRY',
  SEND_OTP = 'SEND_OTP',
  VERIFY_OTP = 'VERIFY_OTP',
  CREATE_INVEST_PAYMENT = 'CREATE_INVEST_PAYMENT',
  FETCH_PORTFOLIO = 'FETCH_PORTFOLIO',
  FETCH_INVEST = 'FETCH_INVEST',
  FETCH_TRANSACTIONS = 'FETCH_TRANSACTIONS',
  FETCH_TRANSACTION_DETAIL = 'FETCH_TRANSACTION_DETAIL',
  FETCH_PROFILE = 'FETCH_PROFILE',
}

export const API_ENDPOINTS = {
  [ApiEndpoint.RESOLVE_ENTRY]: { apiPath: '/v1/investor-portal/resolve', httpMethod: 'POST' },
  [ApiEndpoint.SEND_OTP]: { apiPath: '/v1/investor-portal/otp', httpMethod: 'POST' },
  [ApiEndpoint.VERIFY_OTP]: { apiPath: '/v1/investor-portal/otp/verify', httpMethod: 'POST' },
  [ApiEndpoint.CREATE_INVEST_PAYMENT]: { apiPath: '/v1/invest', httpMethod: 'POST' },
  [ApiEndpoint.FETCH_PORTFOLIO]: { apiPath: '/v1/portfolio', httpMethod: 'GET' },
  [ApiEndpoint.FETCH_INVEST]: { apiPath: '/v1/invest', httpMethod: 'GET' },
  [ApiEndpoint.FETCH_TRANSACTIONS]: { apiPath: '/v1/transactions', httpMethod: 'GET' },
  [ApiEndpoint.FETCH_TRANSACTION_DETAIL]: { apiPath: '/v1/transactions/:transaction_id', httpMethod: 'GET' },
  [ApiEndpoint.FETCH_PROFILE]: { apiPath: '/v1/me', httpMethod: 'GET' },
} as const satisfies Record<ApiEndpoint, { apiPath: string; httpMethod: THttpMethod }>;
